const TopicLoading = () => {
  return (
    <div>
      <div className="w-full flex flex-col gap-[24px] animate-pulse">
        <div className="w-[90%] h-[20px] bg-gray-300 rounded-full"></div>
        <div className="w-[80%] h-[20px] bg-gray-300 rounded-full"></div>
        <div className="w-[70%] h-[20px] bg-gray-300 rounded-full"></div>
      </div>
    </div>
  );
};

export default TopicLoading;
